import type { ReactNode } from "react";

import { Lock } from "./icons";
import { cn } from "./cn";

export type BadgeTone =
  | "success"
  | "warning"
  | "error"
  | "info"
  /** "Needs attention, but not an error" — e.g. a protocol conflict. */
  | "neutral"
  /** Brand colour, e.g. a select option coloured "accent". */
  | "accent"
  /** Immutable System Ability marker. A marker, never a status. */
  | "system";

const TONE: Record<BadgeTone, string> = {
  success: "bg-success-bg text-success",
  warning: "bg-warning-bg text-warning",
  error: "bg-error-bg text-error",
  info: "bg-info-bg text-info",
  neutral: "bg-neutral-bg text-neutral",
  accent: "bg-accent-subtle text-accent-fg",
  system: "bg-system-subtle text-system",
};

export interface BadgeProps {
  tone?: BadgeTone;
  children: ReactNode;
  className?: string;
}

export function Badge({ tone = "neutral", children, className }: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-caption font-semibold",
        TONE[tone],
        className,
      )}
    >
      {tone === "system" && <Lock size={12} />}
      {children}
    </span>
  );
}
